import uiI18n from "../i18n";
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useRef, useState } from 'react';
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { FcGoogle } from 'react-icons/fc';
import { toast } from 'react-toastify';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from "../firebase"; // Import de Firestore configuré
import { useNavigate } from "react-router-dom";

// The user closed or replaced the Google window: not an error, return silently.
const CANCEL_CODES = ['auth/popup-closed-by-user', 'auth/cancelled-popup-request', 'auth/user-cancelled'];

const OAuth = () => {
  useUiTranslation();
  const navigate = useNavigate(); // Initialisation de useNavigate
  const [pending, setPending] = useState(false);
  const pendingRef = useRef(false); // blocks a second click before the re-render

  async function onGoogleClick() {
    if (pendingRef.current) return;
    pendingRef.current = true;
    setPending(true);
    let stage = 'firebase-auth';
    try {
      // Initialisation Firebase Auth et Provider Google
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      stage = 'firestore-profile';

      // Vérifier si l'utilisateur existe dans Firestore
      const docRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        // Ajouter un nouvel utilisateur dans Firestore
        await setDoc(docRef, {
          name: user.displayName,
          email: user.email,
          timestamp: serverTimestamp(),
        });
      }

      // Affiche un message de succès
      toast.success(uiI18n.t("ui.signed_in_with_google"));
 
      // Redirection vers la page d'accueil
      navigate("/");
    } catch (error) {
      // Safe diagnostic only: never serialize the Firebase error (may contain credentials).
      const knownCodes = ['auth/popup-blocked', 'auth/popup-closed-by-user', 'auth/cancelled-popup-request', 'auth/user-cancelled', 'auth/unauthorized-domain', 'auth/operation-not-allowed', 'auth/web-storage-unsupported', 'auth/network-request-failed', 'auth/internal-error', 'auth/account-exists-with-different-credential', 'permission-denied', 'unavailable', 'unauthenticated'];
      const code = knownCodes.includes(error?.code) ? error.code : 'unknown';
      console.warn('Google sign-in failed', { stage, code });
      pendingRef.current = false;
      setPending(false);
      if (CANCEL_CODES.includes(code)) return;
      const message = code === 'auth/popup-blocked' ? "ui.google_popup_blocked"
        : code === 'auth/network-request-failed' ? "ui.google_network_error"
        : "ui.unable_to_sign_in_with_google";
      toast.error(uiI18n.t(message));
    }
  }

  return (
    <button
      type="button"
      onClick={onGoogleClick}
      disabled={pending}
      aria-busy={pending}
      className="flex items-center justify-center w-full disabled:opacity-70 disabled:cursor-wait bg-red-700 text-white px-7 py-3 uppercase text-sm font-medium hover:bg-red-800 active:bg-red-900 shadow-md hover:shadow-lg active:shadow-lg transition duration-150 ease-in-out rounded"
    >
      <FcGoogle className="rounded-full me-2" /> {uiI18n.t(pending ? "ui.signing_in_with_google" : "ui.continue_with_google")} </button>
  );
};

export default OAuth;
